import React from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const AdminMenu = ({ setSidebarVisible }) => {
  const history = useHistory();

  const navigateTo = link => {
    setSidebarVisible(false);
    history.push(link);
  };

  return (
    <ul className="mobile-navbar-list">
      <li className="mobile-navbar-list-item">
        <button
          type="button"
          onClick={() => navigateTo('/users')}
          className="mobile-navbar-list-item-inner"
        >
          <p className="mobile-navbar-menu-item">Manage Account</p>
        </button>
      </li>
      <li className="mobile-navbar-list-item">
        <button
          type="button"
          onClick={() => navigateTo('/manage-control/dealerships')}
          className="mobile-navbar-list-item-inner"
        >
          <p className="mobile-navbar-menu-item">Manage Control</p>
        </button>
      </li>
    </ul>
  );
};

AdminMenu.propTypes = {
  setSidebarVisible: PropTypes.func.isRequired
};

export default AdminMenu;
